import { WAREHOUSE_DEFINITIONS } from '@fielded/fs-api/lib/order/tools/read/warehouse-code-to-virtual'
import { getUppercaseTenant } from '../../van-shared/utils/utils'

export const VIEWS = {
  ALL: 'all',
  SINGLE: 'single'
}

export const REPORT_STATUS = {
  PROCESSING: 'processing',
  COMPLETED: 'completed'
}

export const REPORT_STATUS_TO_LABEL = {
  [REPORT_STATUS.PROCESSING]: 'preparing',
  [REPORT_STATUS.COMPLETED]: 'prepared'
}

export const REPORT_STATUS_TO_STATUS_LABEL = {
  [REPORT_STATUS.PROCESSING]: 'progress',
  [REPORT_STATUS.COMPLETED]: 'success'

}

export const getSubViewLinks = (pathname, view) => {
  return [
    {
      title: 'All branches',
      active: view === VIEWS.ALL,
      path: {
        state: { view: VIEWS.ALL },
        pathname
      }
    },
    {
      title: 'Single branch',
      active: view === VIEWS.SINGLE,
      path: {
        state: { view: VIEWS.SINGLE },
        pathname
      }
    }
  ]
}

export const getAllBranches = (config) => {
  const tenant = getUppercaseTenant(config)

  return Object.values(WAREHOUSE_DEFINITIONS[tenant]).map(warehouse => {
    return {
      // TODO: change the value to warehouse._id when the API is updated
      // value: warehouse._id,
      value: warehouse.warehouseCode,
      label: warehouse.name || warehouse._id
    }
  })
}
